export default "/_next/static/images/2015-2x-646aaa4fc7ac7502b3d5119fa0f742ea.png";